<template>
  <div class="wc-account-window-section-desktop bg-white px-4 pt-4 pb-5 mb-3">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DashboardWindowSection',
};
</script>

<style scoped></style>
